module.exports = __webpack_public_path__ + "static/media/theft.a3be5225.svg";